<template>
  <div class="header">
    <div class="wrapper">
      <a-row :gutter="16" type="flex">
        <a-col>
          <span class="t-label">Filtruj:</span>
        </a-col>

        <a-col style="flex: 1;">
          <a-row type="flex" class="ant-row-flex-multiline" :gutter="16">
            <a-col>
              <a-select
                class="c-ghost-input"
                showSearch
                v-model="is_group"
                :options="courseTypes"
                allowClear
                placeholder="Typ zajęć"
                optionFilterProp="children"
                style="width: 176px"
              />
            </a-col>
            <a-col>
              <a-select
                class="c-ghost-input"
                showSearch
                v-model="language"
                :options="languages"
                allowClear
                placeholder="Język"
                optionFilterProp="children"
                style="width: 160px"
              />
            </a-col>
            <a-col>
              <a-select
                class="c-ghost-input"
                showSearch
                v-model="level"
                :options="availableLevels"
                allowClear
                mode="multiple"
                placeholder="Poziom"
                optionFilterProp="children"
                style="width: 144px"
              />
            </a-col>
            <a-col>
              <a-select
                class="c-ghost-input"
                v-model="is_completed"
                :options="completedOptions"
                allowClear
                placeholder="Status kursu"
                optionFilterProp="children"
                style="width: 160px"
              />
            </a-col>
          </a-row>
        </a-col>
      </a-row>

      <div>
        <a-input-search
          v-model="search"
          placeholder="Szukaj"
          style="width: 248px"
          class="c-ghost-input"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ListHeader from '@/components/layout/ListHeader'
import { Language } from '@/api'

export default {
  queryModels: ['search', 'is_group', 'language', 'level', 'is_completed'],
  extends: ListHeader,
  data() {
    return {
      lecturers: this.lecturers,
      languages: [],
      availableLevels: [],
      courseTypes: [
        { label: 'Kursy indywidualne', value: 'false' },
        { label: 'Kursy grupowe', value: 'true' }
      ],
      completedOptions: [
        { label: 'W trakcie', value: 'false' },
        { label: 'Zakończone', value: 'true' }
      ]
    }
  },
  created() {
    Language.all().then(res => {
      this.languages = res.data.results.map(language => ({
        label: language.name,
        value: language.id
      }))
    })
    Language.levels().then(res => {
      this.availableLevels = res.data
    })
  }
}
</script>
